import { defineStore } from 'pinia';

interface Notification {
  id: string;
  type: 'success' | 'error';
  title: string;
  message: string;
}

const useNotificationStore = defineStore('notifications', {
  state: () => ({
    notifications: [] as Notification[],
  }),

  actions: {
    showSuccess(title: string, message: string) {
      const notification: Notification = {
        id: Date.now().toString(),
        type: 'success',
        title,
        message,
      };
      this.notifications.push(notification);
      this.removeNotificationAfterDelay(notification.id);
    },

    showError(title: string, message: string) {
      const notification: Notification = {
        id: Date.now().toString(),
        type: 'error',
        title,
        message,
      };
      this.notifications.push(notification);
      this.removeNotificationAfterDelay(notification.id);
    },

    removeNotification(id: string) {
      const index = this.notifications.findIndex((n) => n.id === id);
      if (index > -1) {
        this.notifications.splice(index, 1);
      }
    },

    removeNotificationAfterDelay(id: string, delay = 5000) {
      setTimeout(() => {
        this.removeNotification(id);
      }, delay);
    },

    clearAll() {
      this.notifications = [];
    },
  },
});

export { useNotificationStore };
export default useNotificationStore;
